import React from 'react';
import { useTranslation } from 'react-i18next';
import type { ForgotPasswordFormData } from '@jwp/ott-common/types/account';
import type { FormErrors } from '@jwp/ott-common/types/form';
import { testId } from '@jwp/ott-common/src/utils/common';

import Button from '../Button/Button';
import TextField from '../TextField/TextField';
import FormFeedback from '../FormFeedback/FormFeedback';

import styles from './ForgotPasswordForm.module.scss';
import { useTheme } from '../../../../../ThemeContext';

type Props = {
  onSubmit: React.FormEventHandler<HTMLFormElement>;
  onChange: React.ChangeEventHandler<HTMLInputElement | HTMLTextAreaElement>;
  onBlur: React.FocusEventHandler<HTMLInputElement | HTMLTextAreaElement>;
  error?: string;
  errors: FormErrors<ForgotPasswordFormData>;
  value: ForgotPasswordFormData;
  submitting: boolean;
};

const ForgotPasswordForm: React.FC<Props> = ({ onSubmit, onChange, value, errors, submitting, onBlur }: Props) => {
  const { t } = useTranslation('account');
  const { universalStyles } = useTheme();

  return (
    <form onSubmit={onSubmit} data-testid={testId('forgot-password-form')} noValidate className={styles.forgotPasswordForm}>
      <h2 className={styles.title} style={universalStyles.primaryTextColor}>
        {t('reset.forgot_password')}
      </h2>
      {errors.form ? <FormFeedback variant="error">{errors.form}</FormFeedback> : null}
      {/* <p className={styles.text}>{t('reset.forgot_text')}</p> */}
      <TextField
        value={value.email}
        onChange={onChange}
        onBlur={onBlur}
        label={t('reset.email')}
        placeholder={t('reset.email_placeholder')}
        error={!!errors.email || !!errors.form}
        helperText={errors.email}
        name="email"
        type="email"
        autoComplete="email"
        required
        customStyle={universalStyles.primaryTextColor}
      />
      <Button
        type="submit"
        className={styles.button}
        fullWidth
        color="primary"
        size="exlarge"
        disabled={submitting}
        label={t('reset.reset_password_button')}
        textStyle={universalStyles.primaryThemeButtonText}
        style={universalStyles.signUpButton}
      />
    </form>
  );
};

export default ForgotPasswordForm;
